function AboutCard() {
  return (
    <div className="terminal-window">
      <div className="terminal-header">
        <span className="terminal-dot red"></span>
        <span className="terminal-dot yellow"></span>
        <span className="terminal-dot green"></span>
        <span className="terminal-filename">about.txt</span>
      </div>
      <div className="terminal-body">
        Based in Brooklyn, I’m a forward-deployed engineer at Microsoft on the Data & AI team. My background is in CS and psychology, and I think of myself as a human-focused designer first.

        I’m drawn to problems that live at the edge of technology and behavior. The best solutions usually require understanding both. Outside of work I’m cycling or in the kitchen. I’ve been getting into process cooking lately, fermentation, long braises, that kind of thing. Anything that takes time and attention to get right.
      </div>
    </div>
  );
}

export default AboutCard;
